import { render, staticRenderFns } from "./FacialOrderPrint.vue?vue&type=template&id=ded944f4&scoped=true"
import script from "./FacialOrderPrint.vue?vue&type=script&lang=js"
export * from "./FacialOrderPrint.vue?vue&type=script&lang=js"
import style0 from "./FacialOrderPrint.vue?vue&type=style&index=0&id=ded944f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded944f4",
  null
  
)

export default component.exports